import { asyncRouterMap, constantRouterMap } from '@/router/index';

//判断是否有权限访问该菜单
function hasPermission(menus, route) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus);
    if (currMenu!=null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== '') {
        route.meta.icon = currMenu.icon;
      }
      if(currMenu.hidden!=null){
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort=-1;
        return true;
      } else {
        return false;
      }
    }
  } else {
    return true
  }
}

//根据路由名称获取菜单
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name===menu.name) {
      return menu;
    }
  }
  return null;
}


function getButtonPermissions(menus) {

  console.log("getButtonPermissions - menus:",menus)

  let buttonPermissions = [];
  menus.forEach(menu => {
    // 如果当前菜单有按钮权限，合并到数组中
    if (menu.buttons && Array.isArray(menu.buttons)) {
      buttonPermissions = buttonPermissions.concat(menu.buttons);
    }
  });
  return buttonPermissions;
}


//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if(router.children && router.children.length > 0){
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p){
  return function(m,n){
    let a = m[p];
    let b = n[p];
    return b - a;
  }
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    // 新增：存储按钮权限列表
    buttonPermissions: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    // 新增：设置按钮权限的mutation
    SET_BUTTON_PERMISSIONS: (state, permissions) => {
      state.buttonPermissions = permissions;
    }
    // // 新增：合并按钮权限（去重）
    // MERGE_BUTTON_PERMISSIONS: (state, newPermissions) => {
    //   // 合并后去重，避免重复的权限标识
    //   const merged = [...new Set([...state.buttonPermissions, ...newPermissions])];
    //   state.buttonPermissions = merged;
    // }
  },
  actions: {
    GenerateRoutes({ commit,rootState  }, data) {
      return new Promise(resolve => {
        const { menus } = data;
        const { username } = data;


        // // 1. 从菜单中提取按钮权限
        // const menuButtonPermissions = getButtonPermissions(menus);
        // // 2. 获取 user 模块中的 btnRole
        // const userBtnRole = rootState.user.btnRole || [];
        // // 3. 合并两个来源的权限（去重）
        // const mergedPermissions = [...new Set([...menuButtonPermissions, ...userBtnRole])];
        // // 4. 设置合并后的权限
        // commit('SET_BUTTON_PERMISSIONS', mergedPermissions);


        const accessedRouters = asyncRouterMap.filter(v => {
          //admin帐号直接返回所有菜单
          if(username==='admin') return true;
          if (hasPermission(menus, v)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter(child => {
                if (hasPermission(menus, child)) {
                  return child
                }
                return false;
              });
              return v
            } else {
              return v
            }
          }
          return false;
        });
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    },
    // 新增：手动合并按钮权限的 action（供外部调用，如 user 模块）
    // mergeBtnPermissions({ commit }, newPermissions) {
    //   // 过滤空值，避免传入 undefined 或空数组
    //   const validPermissions = Array.isArray(newPermissions) ? newPermissions.filter(Boolean) : [];
    //   if (validPermissions.length > 0) {
    //     commit('MERGE_BUTTON_PERMISSIONS', validPermissions);
    //   }
    // }
  }
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js